'use client';

import Image from "next/image";
import { Check } from "lucide-react";

type BulletItem = {
  title: string;
};

type BulletItemsSectionProps = {
  bulletItems: BulletItem[];
  image?: string;
  imageAlt?: string;
  heading?: string;
  iconColor?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
};

export function BulletItemsSection({ 
  bulletItems, 
  image, 
  imageAlt, 
  heading,
  iconColor = 'primary' 
}: BulletItemsSectionProps) {
  const iconColorClass = {
    primary: 'text-primary-300',
    secondary: 'text-gray-400',
    success: 'text-green-400',
    warning: 'text-yellow-400',
    danger: 'text-red-400'
  }[iconColor];

  return (
    <div className="flex flex-col md:flex-row max-w-full items-start gap-6">
      {image && (
        <div className="w-[130px] h-[130px] bg-gray-50 rounded-xl flex items-center justify-center shrink-0">
          <Image
            src={image}
            alt={imageAlt || heading || "Image"}
            width={100}
            height={84}
            className="object-contain"
          />
        </div>
      )}
      <div className="flex flex-col gap-3">
        {heading && (
          <h3 className="text-lg font-bold text-gray-900">{heading}</h3>
        )}
        <div className="flex flex-col gap-2">
          {bulletItems.map((bullet, j) => (
            <div key={j} className="flex items-start gap-2 text-primary">
              <Check className={`${iconColorClass} text-xl shrink-0`} />
              <span>{bullet.title}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
